export const SET_COMPANY = 'SET_COMPANY';
export const SET_COMPANYID = 'SET_COMPANYID';
export const SET_RESOURCE = 'SET_RESOURCE';
export const SET_FROMDATE = 'SET_FROMDATE';
export const SET_TODATE = 'SET_TODATE';
export const SET_DETAILS = 'SET_DETAILS';
export const SET_PROJECTID = 'SET_PROJECTID';
export const SET_PROJECTNAME = 'SET_PROJECTNAME';
export const SET_PROJECTQR = 'SET_PROJECTQR';
export const SET_PROJECTREPORT = 'SET_PROJECTREPORT';